$(document).on('click', '.placeholder', function () {
    let selector = $(this).parent().data('selector');
    let placeholder = $(this).data('placeholder');

    if (selector.charAt(0) === '$') {
        selector = eval(selector);
    }

    $(selector).insertAtCaret(placeholder);
});
